import React, { Fragment } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { headerLogoConfig } from '../configs/headerLogoConfigs';

const Logo = ({ logoUrl, logo, logoMobile, stateCode, name, carrierLogoUrl, logoUrlMobile, micrositeIds }) => {
    const intl = useIntl();
    const logoConfig = stateCode ? headerLogoConfig[stateCode] : [];

    function getLogoImg() {
        return (
            <Fragment>
                { micrositeIds &&
                    <Fragment>
                        <img
                            id="masthead__carrier__logo__img"
                            className="gi-masthead__logo__img gi-masthead__logo__img--carrier"
                            src={carrierLogoUrl}
                            alt={name}
                        />
                        <img
                            id="masthead__carrier__logo__img__mobile"
                            className="gi-masthead__logo__img__mobile gi-masthead__logo__img__mobile--carrier"
                            src={logoUrlMobile}
                            alt={name}
                        />
                    </Fragment>
                }

                <img
                    id="masthead__logo__img"
                    className="gi-masthead__logo__img"
                    src={logo}
                    alt={intl.formatMessage( { id:'header.logo.alt' })}
                />
                <img
                    id="masthead__logo__img__mobile"
                    className="gi-masthead__logo__img__mobile"
                    src={logoMobile}
                    alt={intl.formatMessage( { id:'header.logo.alt' })}
                />
            </Fragment>
        );
    }
    return (
        <Fragment>
            <div
                className="usa-logo gi-masthead__logo"
                id="gi-masthead-logo-wrap"
            >
                <div className="grid-row">
                    {
                        logoConfig.link &&
                        <div className="masthead_logo">
                            <a
                                href={logoUrl}
                                target="_blank"
                                rel="noopener noreferrer"
                                data-automation-id="masthead__logo__url"
                                title={intl.formatMessage({ id:'header.logo.link.title' })}
                            >
                                {
                                    getLogoImg()
                                }
                            </a>
                        </div>
                    }
                    {
                        !logoConfig.link && getLogoImg()
                    }
                    {
                        logoConfig.tagline &&
                        <div className="tagline">
                            <FormattedMessage
                                id = "header.logo.tagline"
                                values={{
                                    sup: function makeTextSup (chunks) { return (<sup>{ chunks }</sup>); }
                                }}
                            />
                        </div>
                    }
                </div>


            </div>
            <div className="usa-menu-btn gi-masthead__nav__btn--collapse">
                {/*<FontAwesomeIcon icon="bars" />*/}
                <span className="icon-bar"></span>
                <span className="icon-bar"></span>
                <span className="icon-bar"></span>
            </div>
        </Fragment>
    );
};


export default Logo;